module.exports = __webpack_public_path__ + "static/media/apple_tv_4K_dark.6116d5df.svg";